<pf-table-toolbar
    #toolbar
    [showSearch]="showSearch"
    [showClearFilters]="showClearFilters"
    [disableClearFilters]="loading"
    [showSelectionToolbar]="!!showSelection"
    [showAdvancedFilterButton]="hasAdvancedFilters"
    (resetTable)="reset()"
    (refreshTable)="refresh()"
    (tableSearch)="onSearchChanged($event)">
    <ng-content
        select="[selection-toolbar]"
        ngProjectAs="[selection-toolbar]"></ng-content>
    <ng-content
        select="[toolbar-title]"
        ngProjectAs="[toolbar-title]"></ng-content>
    <ng-content
        select="[toolbar-left]"
        ngProjectAs="[toolbar-left]"></ng-content>
    @if (editable) {
        <pf-editable-table-actions
            [showSaveButton]="!manualSave"
            (saveChanges)="saveEditedData()"
            toolbar-right></pf-editable-table-actions>
    }
    <ng-content select="[toolbar-right]" ngProjectAs="[toolbar-right]">
    </ng-content>
</pf-table-toolbar>
@if (hasAdvancedFilters) {
    <pf-advanced-filters
        [class]="this.filterService.filtersDisplayed ? 'open' : ''"
        [columns]="columns"
        [tableKey]="tableKey"></pf-advanced-filters>
}
<nz-table
    #table
    [nzLoading]="_loading()"
    [nzData]="tableService.tableState.rows"
    [nzFrontPagination]="!serverRendered && showPagination"
    [nzPageIndex]="tableService.tableState.pageIndex"
    [nzPageSize]="pageSize"
    [nzTotal]="tableService.tableState.total"
    [nzShowPagination]="showPagination"
    [nzFooter]="tableFooterTemplate"
    [nzShowTotal]="showTotalTemplate"
    [nzItemRender]="renderItemTemplate"
    [nzShowSizeChanger]="(pageSizeOptions?.length ?? 0) > 1"
    [nzPageSizeOptions]="pageSizeOptions?.length ? pageSizeOptions : []"
    nzTableLayout="fixed"
    [nzScroll]="scrollSettings"
    [nzSize]="size"
    [nzNoResult]="noResult"
    (nzQueryParams)="onQueryParamsChange($event)"
    (nzPageIndexChange)="pageIndexChanged($event)"
    (nzPageSizeChange)="pageSizeChanged($event)">
    <ng-template #renderItemTemplate let-type let-page="page">
        @switch (type) {
            @case ("page") {
                <a>{{ page }}</a>
            }
            @case ("prev") {
                <a>Previous</a>
            }
            @case ("next") {
                <a>Next</a>
            }
            @case ("prev_5") {
                <a><<</a>
            }
            @case ("next_5") {
                <a>>></a>
            }
        }
    </ng-template>
    <ng-template #showTotalTemplate let-range="range">
        <span
            >{{ range[0] }}-{{ range[1] }} of
            {{ tableService.tableState.total }} items</span
        >
        |
    </ng-template>
    <ng-template #tableFooterTemplate>
        @if (serverRendered && showExport) {
            <pf-button
                buttonType="export"
                [loading]="exporting"
                (click)="exportHandler()"
                >Export
            </pf-button>
        }
        <ng-content select="[footer-left]"></ng-content>
    </ng-template>
    <thead>
        <tr>
            @if (expandable || isDraggable) {
                <th nzWidth="40px"></th>
            }
            @if (showSelection) {
                <th
                    nzWidth="80px"
                    [(nzChecked)]="tableService.checked"
                    [nzIndeterminate]="tableService.indeterminate"
                    (nzCheckedChange)="onAllRowsChecked($event)"></th>
            }
            @for (
                column of tableService.tableState.columns;
                track headerTrackBy($index, column)
            ) {
                <th
                    [nzColumnKey]="column.field"
                    [nzShowSort]="column.showSort && !isDraggable"
                    [(nzSortOrder)]="column.sortOrder"
                    [nzSortDirections]="column.sortDirections"
                    [nzSortFn]="column.sortFn"
                    [nzWidth]="column.width"
                    nzCustomFilter>
                    <pf-table-header
                        [column]="column"
                        (checkChanged)="
                            onTableHeaderChecked(column, $event)
                        "></pf-table-header>
                    @if (
                        column.search ||
                        column.serverSearch ||
                        column.listFilterFacade
                    ) {
                        <pf-table-header-search
                            nz-th-extra
                            [column]="column"
                            (searchChanged)="
                                onColumnSearchChanged(column)
                            "></pf-table-header-search>
                    }
                </th>
            }
            @if (!!actions && actions.length) {
                <th
                    style="text-align: center; font-size: smaller"
                    nzRight
                    [nzWidth]="
                        (actions[0].width ||
                            ((actions[0].name || '').length || 4) * 10 + 30) +
                        'px'
                    ">
                    Actions
                </th>
            }
        </tr>
    </thead>
    <tbody
        cdkDropList
        [cdkDropListDisabled]="!isDraggable || tableService.isFiltered"
        (cdkDropListDropped)="drop($event)">
        <pf-table-rows
            [expandToContent]="expandToContent"
            [columns]="tableService.tableState.columns"
            [actions]="actions"
            [expandRowRef]="expandRowRef"
            [options]="options"
            [expandable]="expandable"
            [expand]="isFiltered"
            [singleExpand]="singleExpand"
            [data]="table.data"
            [isDraggable]="isDraggable"
            [isDraggableDisabled]="tableService.isFiltered"
            [showSelection]="!!showSelection"
            (rowExpanded)="onRowExpanded($event)"></pf-table-rows>
    </tbody>
</nz-table>
